import { Component, OnInit } from '@angular/core';
import { TimezoneService } from "../../services/timezone.service";
import { TranslocoService } from "@ngneat/transloco";
import { PortalLink } from "../../model/interfaces/portal.interfaces";
import { PortalDAO } from "../../daos/portal.dao";
import { LoggedUser } from "../../common/logged-user.service";
import { UserService } from "../../services/user.service";
import { CommonMessagesService } from "../../services/common-messages.service";
import { take } from "rxjs/operators";

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit {

  userData: any;
  userPreferences: any;
  additionalUserData: any;
  applications: any[];

  languages: any[];
  timezones: any[];
  selectedLanguage: any;
  selectedTimezone: any;

  constructor(private timezoneService: TimezoneService,
              private portalDAO: PortalDAO,
              private loggedUser: LoggedUser,
              private userService: UserService,
              private commonMessagesService: CommonMessagesService,
              private translocoService: TranslocoService) {}

  ngOnInit(): void {
    this.buildStaticOptions();
    this.loadPortalLinks();
    this.loggedUser.userObservable.subscribe(user => {
      this.userData = user.attributes;
    });
    this.userService.getAdditionalUserData().subscribe(additionalUserData => {
      this.additionalUserData = additionalUserData;
      this.selectedLanguage = this.languages.filter(lang => lang.langCode === additionalUserData.language)[0];
      this.selectedTimezone = additionalUserData.timezone;
    });
  }

  private loadPortalLinks() {
    this.portalDAO.getPortalLinks().subscribe(response => {
      this.applications = response.filter(item => !item.customApplication);
    });
  }

  guessTimezone() {
    this.timezoneService.guessTimezone();
    this.selectedTimezone = this.timezoneService.getCurrentTimezone();
  }

  onTimezoneChange(event: any) {
    this.timezoneService.setTimezone(event.value);
  }

  private buildStaticOptions() {
    this.languages = [
      {name: 'Español', code: 'es', langCode: 'es'},
      {name: 'English', code: 'gb', langCode: 'en'},
    ];
    this.timezones = this.timezoneService.getAllTimezones();
  }

  onSaveChanges() {
    let promises = [];
    promises.push(this.userService.updateUserTimezone(this.selectedTimezone).toPromise());
    promises.push(this.userService.updateUserLanguage(this.selectedLanguage.langCode).toPromise());
    Promise.all(promises).then(() => {
      this.translocoService.setActiveLang(this.selectedLanguage.langCode);
      this.translocoService.selectTranslate('common.save').pipe(take(1)).subscribe(() => {
        this.commonMessagesService.showChangesSavedMessage();
      });
    });
  }
}
